import H from "styled-components";
const I = (i, p) => {
  const { $gutter: n, $gutterX: a, $gap: o, $gapX: $ } = i;
  let e = 0, r = 0;
  return n ? e = n : a && (e = a * p), o ? r = o : $ && (r = $ * p), `${r}px ${e}px`;
}, J = H.div(
  ({
    theme: i,
    $position: p,
    $flexDirection: n = "column",
    $inherit: a,
    $flexWrap: o = !1,
    $flexGap: $,
    $flexGapX: e,
    $flexRowGap: r,
    $flexRowGapX: s,
    $flexColumnGap: x,
    $flexColumnGapX: c,
    $gutter: F,
    $gutterX: V = 0,
    $gap: j,
    $gapX: k = 0,
    $marginBottom: g,
    $marginBottomX: d,
    $width: l,
    $widthX: f,
    $height: u,
    $heightX: y,
    $alignSelf: z,
    $alignItems: q,
    $justifyContent: A,
    $background: m,
    $borderColor: b,
    $borderRadius: w,
    $borderRadiusX: P,
    $opacity: D = 1,
    $hidden: E = !1
  }) => {
    const { layout: t, colors: v } = i;
    return `
      ${p ? `position: ${p};` : ""}
      display: flex;
      ${E ? "display: none;" : ""}
      flex-wrap: ${o ? "wrap" : "nowrap"};
      ${a ? "flex-grow: 1; flex-shrink: 1;" : ""}
      flex-direction: ${n};
      padding: ${I({ $gutter: F, $gutterX: V, $gap: j, $gapX: k }, t.gutter)};
      margin-bottom: ${g ? `${g}` : "initial"}${typeof g == "number" ? "px" : ""};
      ${d ? `margin-bottom: ${d * t.gutter}px;` : ""}
      align-self: ${z || "auto"};
      align-items: ${q || "normal"};
      justify-content: ${A || "flex-start"};
      background-color: ${m ? v[m] : "transparent"};
      border-radius: ${typeof w == "number" ? w : 0}px;
      ${P ? `border-radius: ${P * t.gutter}px;` : ""}
      ${b ? `border: 1px solid ${v[b]};` : ""}
      opacity: ${D};
      width: ${l ? `${l}` : "auto"}${typeof l == "number" ? "px" : ""};
      ${f ? `width: ${f * t.gutter}px;` : ""}
      height: ${u ? `${u}` : "auto"}${typeof u == "number" ? "px" : ""};
      ${y ? `height: ${y * t.gutter}px;` : ""}
      ${$ ? `gap: ${$}px;` : ""}
      ${e ? `gap: ${e * t.gutter}px;` : ""}
      ${r ? `row-gap: ${r}px;` : ""}
      ${s ? `row-gap: ${s * t.gutter}px;` : ""}
      ${x ? `column-gap: ${x}px;` : ""}
      ${c ? `column-gap: ${c * t.gutter}px;` : ""}
  `;
  }
), L = J;
export {
  L as default
};
//# sourceMappingURL=flex-view.js.map
